export const CATEGORIES = [
  'Franco-Belge',
  'Manga',
  'Super-héros',
  'Humour',
  'Aventure',
  'Science-fiction',
  'Fantastique',
  'Policier',
  'Historique',
  'Autre',
]

export const LANGUAGES = ['FR', 'EN']
